import React from 'react'
import ReactDOM from 'react-dom/client'
import { ApiProvider, App, resolveVariantApp } from '@tn/ui'
import type { IApiClient } from '@tn/ui'
import '@tn/ui/styles.css'
import { HttpApiClient } from './HttpApiClient'
import { EsoAuthGate } from './EsoAuthGate'
import { variantApps } from './variantApps'

const base = { App, api: (): IApiClient => new HttpApiClient('/api') }
const { App: RootApp, api } = resolveVariantApp(window.location.pathname, variantApps, base)
const apiClient = api()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found')
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <EsoAuthGate>
      <ApiProvider client={apiClient}>
        <RootApp />
      </ApiProvider>
    </EsoAuthGate>
  </React.StrictMode>
)
